import {
    Block,
    IBlockProcessor,
    KnowledgeCheckBlock
} from 'src/shared/wysiwyg/ultra/UltraBlockProcessing/UltraBlockInterfaces';
import { UnsupportedBlockError } from 'src/shared/wysiwyg/ultra/UltraBlockProcessing/UnsupportedBlockError';

export class KnowledgeCheckBlockProcessor implements IBlockProcessor<KnowledgeCheckBlock> {

    protected readonly container: HTMLElement;

    constructor(container: HTMLElement) {
        this.container = container;
    }

    async process(block: Block): Promise<string> {
        throw new UnsupportedBlockError(`Knowledge Check blocks are not yet supported : ${ block.id}`);
    }
}
